





















































































































































import Vue, { PropType } from 'vue'
import UserCard from '@/components/UserCard.vue'
import {
  DeliveryCurrenciesEnum,
  Remittance,
} from '@/utils/interfaces/remittance.interface'
import ActionButton from '@/components/ActionButton.vue'
import { formatCurrency, getCardInfo, getText } from '@/utils/functions'
import { Iterable } from '@/utils/interfaces'
import { message } from '@/store/modules/notifications'

export default Vue.extend({
  components: {
    appUserCard: UserCard,
    appActionButton: ActionButton,
  },
  props: {
    item: Object as PropType<Remittance>,
  },
  data() {
    return {
      fields: ['identity', 'first_name', 'last_name', 'email', 'phone'],
      DeliveryCurrenciesEnum,
    }
  },
  computed: {
    shouldIncludeCardInfo() {
      return [
        DeliveryCurrenciesEnum.MLC,
        DeliveryCurrenciesEnum.MLX,
        DeliveryCurrenciesEnum.UST,
      ].includes(this.item.delivery_currency)
    },
  },
  methods: {
    getCardInfo,
    async copyText() {
      try {
        const client_origin_fields = ['first_name', 'last_name', 'phone']
        const client_destiny_fields = [
          'identity',
          'first_name',
          'last_name',
          'indentity',
          'full_address',
          'phone',
          'landline',
        ]
        if (this.shouldIncludeCardInfo) {
          client_destiny_fields.push('credit_card', 'account_number')
        } else {
          if (
            this.item.client_destiny_obj.credit_card &&
            !getCardInfo(this.item.client_destiny_obj.credit_card)
          ) {
            client_destiny_fields.push('credit_card')
          }
        }
        const client_origin = client_origin_fields.map(field => ({
          text: this.$t(field),
          field: field,
        }))
        const client_destiny = client_destiny_fields.map(field => ({
          text: this.$t(field),
          field: field,
        }))
        let text = ''
        text += `${this.$t('client-origin')}\n`
        text += getText(this.item.client_origin_obj as Iterable, client_origin)
        text += `${this.$t('amount_sent')}: ${formatCurrency(
          this.item.amount,
        )}\n`

        text += `\n${this.$t('client-destiny')}\n`
        text += getText(
          this.item.client_destiny_obj as Iterable,
          client_destiny,
        )
        if (this.shouldIncludeCardInfo) {
          text += `${this.$t('card')} ${getCardInfo(
            this.item.client_destiny_obj.credit_card,
          )}\n`
        }

        text += `\n${this.$t('remittance.remittance')}\n`
        const remittance_fields = ['code', 'description']
        const remittance = remittance_fields.map(field => ({
          text: this.$t(field),
          field: field,
        }))
        text += getText(this.item as Iterable, remittance)
        text += `${this.$t('delivery_amount')}: ${
          this.item.delivery_currency
        } ${Number(this.item.delivery_amount).toLocaleString('en-US', {
          minimumFractionDigits: 2,
        })}\n`
        text += `${this.$t('status')}: ${this.$t(this.item.status)}\n`
        text += `${this.$t('created-at')}: ${this.$options.filters?.dateTime(
          this.item.created_at,
        )}\n`

        if (navigator.clipboard) {
          await navigator.clipboard.writeText(text)
        }
      } catch (error) {
        const message = {
          text: this.$t('error-copying'),
          title: 'Ups!',
          icon: 'mdi-content-copy',
          description: this.$t('error-copying'),
          color: 'error',
        } as message
        this.$store.commit('notifications/displayMessage', message)
      }
    },
  },
})
